import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PaymentAuthApp } from 'payments-auth-lib';
import { SectionHeading } from 'web-ui-components/lib/molecules/text';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import PaymentHistorySME from './PaymentHistorySME';
import UserManagementStore from '../../../stores/UserManagementStore';
import AccountsStore from '../../../stores/AccountsStore';
import PreferencesStore from '../../../stores/PreferencesStore';
import { getPaymentHistoryList } from '../../../actions/PaymentsHistorySMEActionCreator';
import InternetBankingActions from '../../../actions/InternetBankingActions';
import { resetPaymentHistory } from '../../../actions/PaymentsHistorySMEActionCreator';
import {
  GenericChatComponent,
  getChatContent,
} from '../../common/GenericChatComponent';
import {
  setPaymentAuthList,
  setPaymentAuthToEdit,
} from '../../../actions/MoveMoneySMEActionCreator';
import FavouritesStore from '../../../stores/AccountsStore/FavouritesStore';
import { clearSelectedAccountIdForPaymentHistory } from '../../../actions/PaymentStatusActionCreator';
import FavouritesActionCreator from '../../../actions/AccountsActionCreator/FavouritesActionCreator';
import { BioCatchContext } from '../../BioCatchContext';
import { VIEW_PAYMENT_DETAILS_CONTEXT } from '../../../config/BioCatch';
import envConfig from '../../../../static/config';

class PaymentStatusHomeSME extends Component {
  constructor(props) {
    super(props);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.handleAuthListing = this.handleAuthListing.bind(this);
    this.handleHistoryListing = this.handleHistoryListing.bind(this);

    this.state = {
      isAuthListing: true,
      isHistoryListing: true,
      accountList: AccountsStore.getAllAccountsForPaymentsHistory(),
      isGroupApprovalsEnabled: PreferencesStore.getIsGroupApprovalsEnabled(),
    };
  }

  componentWillUnmount() {
    if (!FavouritesStore.isLargeCustomer()) {
      resetPaymentHistory();
    }
    clearSelectedAccountIdForPaymentHistory();
    FavouritesActionCreator.clearSelectedAccountId();
  }

  handleEdit(paymentsType, paymentsWithDetails) {
    setPaymentAuthList(paymentsType, paymentsWithDetails);
    InternetBankingActions.navigateToWebTask('WEB-OPEN-MOVEMONEY-PAYMENTS');
  }
  handleEditById(paymentsType, paymentToEdit) {
    setPaymentAuthToEdit(paymentsType, paymentToEdit);
    InternetBankingActions.navigateToWebTask('WEB-OPEN-MOVEMONEY-PAYMENTS');
  }

  handleRefresh() {
    getPaymentHistoryList();
  }

  handleAuthListing(isAuthListing) {
    this.setState({ isAuthListing });
  }

  handleHistoryListing(isHistoryListing) {
    this.setState({ isHistoryListing });
  }

  render() {
    const { content, handleRoute, handleBack, session, onShowAccountPicker } =
      this.props;

    const { isGroupApprovalsEnabled } = this.state;

    const { smePaymentHistoryTitle, smePaymentHistoryIntroduction } = content;
    const { isAuthListing, isHistoryListing, accountList } = this.state;
    const showPaymentHistory =
      accountList && AccountsStore.getTotalNumberOfAccounts() > 0;
    const user = UserManagementStore.getCADetails();
    const isSmeUser = UserManagementStore.isSMEUser();

    return (
      <BioCatchContext context={VIEW_PAYMENT_DETAILS_CONTEXT}>
        <div>
          {isHistoryListing && isAuthListing && (
            <div className="web-ui-components">
              <div className="row">
                <div className="col-sm1-24 col-md1-18">
                  <BackButton onClick={handleBack} />
                  <SectionHeading heading1={smePaymentHistoryTitle} />
                  <div className="noprint">
                    <p>{smePaymentHistoryIntroduction}</p>
                  </div>
                </div>
                <div className="col-sm1-24 col-md1-6 u-margin-bottom-2">
                  <GenericChatComponent
                    content={getChatContent(this.props.content)}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-sm1-24">
              <div
                style={
                  isHistoryListing ? { display: 'block' } : { display: 'none' }
                }
              >
                <PaymentAuthApp
                  handleBack={handleBack}
                  handleEdit={this.handleEdit}
                  handleEditById={this.handleEditById}
                  handleRoute={handleRoute}
                  handleRefresh={this.handleRefresh}
                  handleIsListing={this.handleAuthListing}
                  accounts={AccountsStore.getAll()}
                  session={session}
                  envConfig={envConfig}
                  user={user}
                  isLCV={FavouritesStore.isLargeCustomer()}
                  isSme={isSmeUser}
                  hasGroupApprovalsEnabled={!!isGroupApprovalsEnabled}
                />
              </div>
              {showPaymentHistory && (
                <div
                  style={
                    isAuthListing ? { display: 'block' } : { display: 'none' }
                  }
                >
                  <PaymentHistorySME
                    content={content}
                    handleBack={handleBack}
                    handleIsListing={this.handleHistoryListing}
                    accountList={accountList}
                    user={user}
                    session={session}
                    onShowAccountPicker={onShowAccountPicker}
                    envConfig={envConfig}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </BioCatchContext>
    );
  }
}

PaymentStatusHomeSME.propTypes = {
  content: PropTypes.object.isRequired,
  session: PropTypes.object.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleRoute: PropTypes.func.isRequired,
  onShowAccountPicker: PropTypes.func.isRequired,
};

export default PaymentStatusHomeSME;
